<template>
  <div>
    <!-- <WorkPopup></WorkPopup> -->
    <div class="breadcrumbs container mx-auto my-6">
      <nuxt-link :to="localePath('index')" class="breadcrumb  px-2">
        {{ $t('home') }}</nuxt-link
      >
      <nuxt-link :to="localePath('local-information')" class="breadcrumb  px-2">
        {{ $t('LOCAL_INFORMATION') }}</nuxt-link
      >
      <!-- console.log('market', market) on click -->
 
    <nuxt-link
        :to="
          localePath({
            name: 'local-information-slug',
            params: { slug: market.slug }
          })
        "
        class="breadcrumb  px-2"
      >
        {{ market.name[this.$i18n.locale] }}</nuxt-link
      > 
    </div>
    <iframe src="https://m-one-bosnia.netlify.app/" class="w-full h-screen"></iframe>
  </div>
</template>

<script>
import markets from '~/static/markets.json'

export default {
  data() {
    return {
      showModal: false
    }
  },
  asyncData({ route, params }) {
    // const slug = params.slug
    // const market = markets.find(market => {
    //   return market.slug === slug
    // })

    // return { market }
    const country = "bosnia"
    const market = markets.find(market => {
      return market.slug === country
    })
    return { market }
  },
  methods: {
    consoleLog() {
        // eslint-disable-next-line
      console.log('market', this.market)
    }
  }
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
